import { useCallback, useState } from "react";
import { api } from "../../lib/api";
import type { ChecklistCommand } from "../../lib/api-client/contracts";
import { WorkChecklist } from "../../components/WorkChecklist";
import { WorkReports } from "../../components/WorkReports";
import { WorkHistory } from "../../components/WorkHistory";
import { WorkLayout } from "../../components/WorkLayout";
import type { Contract } from "./model";

/** The financial workspace consumes the original engagement's Work identity;
 * it never creates a second checklist, report feed or history. */
export function JobContractWork({ contract }: { contract: Contract }) {
  const id = contract.sourceId;
  const load = useCallback(() => api.engagementWork(id), [id]);
  const save = useCallback((command: ChecklistCommand) => api.engagementChecklistCommand(id, command), [id]);
  const writable = contract.status === "funded";
  const [denied, setDenied] = useState(false);
  const clearAccess = useCallback(() => setDenied(true), []);
  if (denied) return <p role="alert" className="text-sm text-brand-red">This work record is no longer available in the selected account or profile.</p>;
  return <WorkLayout checklist={<WorkChecklist loadWork={load} saveCommand={save} writable={writable}
    refreshKey={contract.status} minimumLabel={1} maximumLabel={300} roleLabels={{ employer: "Employer", worker: "Worker" }} onAccessLost={clearAccess} />}
    history={<WorkHistory kind="engagement" id={id} refreshKey={contract.status} onAccessLost={clearAccess} />}>
    <WorkReports kind="engagement" id={id} writable={writable} refreshKey={contract.status} onAccessLost={clearAccess} />
  </WorkLayout>;
}
